
import { defineComponent, PropType } from 'vue'
import { mapActions } from 'vuex'
import { OrgGroupsActions } from '~/store/control-panel/groups'
import { EnterpriseGroup } from '~/types/types'
import MutationFailedError from '~/utils/mutationFailedError'

export default defineComponent({
  name: 'DeleteGroupButton',
  props: {
    group: {
      type: Object as PropType<EnterpriseGroup>,
      required: true
    },
    emitRefetch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDeleteGroupConfirm: false,
      isDeletingGroup: false
    }
  },
  methods: {
    ...mapActions('control-panel/groups', {
      deleteOrgGroup: OrgGroupsActions.DELETE_GROUP
    }),
    showConfirm() {
      this.showDeleteGroupConfirm = true
    },
    async deleteGroup(groupId: string, close: () => void) {
      this.isDeletingGroup = true
      try {
        const response = await this.deleteOrgGroup({ groupId })
        if (!response) {
          throw new MutationFailedError('An error occurred while deleting group, please try again.')
        }
        this.$toast.success('Group deleted successfully.')
        if (close) close()
        if (this.emitRefetch) this.$emit('refetch')
        else this.$router.push('/control-panel/user-management/groups')
      } catch (e) {
        this.$toast.danger((e as Error).message)
        this.$emit('refetch')
        if (close) close()
      } finally {
        this.isDeletingGroup = false
      }
    }
  }
})
